export const essentialPatientFields = [
  "birthday",
  "firstName",
  "lastName",
  "gender",
];
